import React from 'react'
import ReactDOM from 'react-dom'
import { AppContext, defaultState } from '../../config/context'
import Jump from './component/jump'
import '../../common/util/channel'
import '../../common/util/polyfill'
import initReportEnv from '../../common/util/report'

initReportEnv('跳转页')

class App extends React.Component {
    constructor() {
        super()
        this.updateUserInfo = user => {
            this.setState(state => ({
                user: {
                    ...state.user,
                    ...user
                }
            }))
        }
        this.state = {
            ...defaultState,
            updateUserInfo: this.updateUserInfo
        }
    }

    render() {
        return <AppContext.Provider value={this.state}>
            <Jump></Jump>
        </AppContext.Provider>
    }
}

ReactDOM.render(<App />, document.getElementById('dokodemodoa'))